export default dest => class Logger {
  constructor(name) {
    ['error', 'warn', 'info', 'debug', 'spam', 'log'].forEach((level) => {
      this[level] = (...args) => {
        dest({ time: Date.now(), level, name, args });
      };
    });

    this.info('created');
  }
};

export const pipeToLogger = (destLogger =>
  ({ level, name, args }) => destLogger[level](name, ...args)
);



// WEBPACK FOOTER //
// ./src/js/RaptorSession/Logger.js